import { ApiError, RequestAbortError } from '../api/client.js';

/** Fixed Spanish for vault failures. The server's own message and the request body are never echoed. */
export function wifiErrorText(error: unknown): string {
  if (error instanceof RequestAbortError) return '';
  if (error instanceof ApiError) {
    if (error.status === 401) return 'Tu sesión ha caducado. Entra de nuevo en ASIS.';
    if (error.status === 429) return 'Espera un momento antes de volver a intentarlo.';
    if (error.status === 404) return 'Esa red ya no existe en tu cuenta. He recargado la lista.';
    if (error.status === 413) return 'Los datos son demasiado largos.';
    if (error.status === 409 && error.code === 'wifi_network_limit') return 'Ya tienes 10 redes guardadas. Elimina alguna para añadir otra.';
    if (error.status === 409) return 'Esa red ha cambiado en otro sitio. He recargado la lista; vuelve a intentarlo.';
    if (error.code === 'invalid_ssid') return 'El nombre de la red no es válido: de 1 a 32 bytes y sin caracteres de control.';
    if (error.code === 'invalid_psk') return 'La contraseña debe tener entre 8 y 63 caracteres ASCII imprimibles.';
    if (error.status === 400) return 'Los datos de la red no son válidos.';
  }
  return 'No se pudo completar la operación. Comprueba la conexión a Internet y reintenta.';
}

/** True when the server says the network list moved on: the caller reloads it. */
export function wifiListIsStale(error: unknown): boolean {
  return error instanceof ApiError && (error.status === 404 || (error.status === 409 && error.code !== 'wifi_network_limit'));
}

const quote = (ssid: string) => `«${ssid}»`;

/** What a unit that keeps `limit` networks will drop from the chosen list; null when everything fits. */
export function networkLimitNote(ssids: readonly string[], limit: number): string | null {
  if (ssids.length <= limit) return null;
  if (limit <= 1) return `Este aparato solo guarda 1 red: se enviará ${quote(ssids[0]!)} y no ${ssids.slice(1).map(quote).join(', ')}.`;
  return `Este aparato guarda hasta ${limit} redes: se enviarán las ${limit} primeras de tu selección.`;
}

export function networksLabel(count: number): string { return count === 1 ? '1 red' : `${count} redes`; }
